<template>
      <div class="row">
        <div class="col-md-12">
            <div class="form-inline">
                <label class="mr-2">Filter Icare</label>
                <select class="form-control" v-model="meta.icare_id" @change="loadIcareFilter">
                    <option value="0">Show All</option>
                    <option v-for="item in icare" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
            <div class="clearfix"><br></div>
        </div>
        <div class="col-md-4 mb-2">
            <div class="form-inline">
                <label class="mr-2">Showing</label>
                <select class="form-control" v-model="meta.per_page" @change="loadPerPage">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <label class="ml-2">Entries</label>
            </div>
        </div>
      
        <div class="col-md-4 offset-md-4"> 

        </div>

        <div class="col-md-12">
            <CDataTable striped hover bordered :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty>


               <template #firstname="{item}">
                 <td v-if="item.firstname"><router-link v-on:click.native="openURL(item.uuid)" to="/">{{item.firstname + ' ' + item.lastname}}</router-link></td>
                <td v-else></td>
              </template>
               <template #profilepic="{item}">
                <td v-if="item.get_photo"><img v-bind:src="getPhoto(item.get_photo.filename)" width="100" height="110"></td>
                <td v-else></td>
              </template>             
               <template #icare="{item}">
                 <td v-if="item.icare_id"><router-link v-on:click.native="openURLICARE(item.icare_id)" to="/">{{item.icare_name}}</router-link></td>
                <td v-else></td>
              </template>
              <template #mobile_phone="{item}">
                  <td v-if="item.mobile_phone == null || item.mobile_phone == ' '"> <CButton v-if="btn_edit_phone" size="sm" variant="outline" color="secondary" class="ml-1" @click="is_uuid ? edit_phone(item.uuid) : edit_phone(item.id)" >Add Phone</CButton>  </td>
                <td v-else> {{item.mobile_phone}} </td>
              </template>
              <template #address1="{item}">
                  <td v-if="item.address1 == null || item.address1== ''"> <CButton v-if="btn_edit_address" size="sm" variant="outline" color="secondary" class="ml-1" @click="is_uuid ? edit_address(item.uuid) : edit_address(item.id)" >Add Address</CButton>  </td>
                <td v-else> {{item.address1}} </td>
              </template>
              <template #dob="{item}">
                  <td v-if="item.dob == null"> <CButton v-if="btn_edit_birthday" size="sm" variant="outline" color="secondary" class="ml-1" @click="is_uuid ? edit_birthday(item.uuid) : edit_birthday(item.id)" >Add Birthday</CButton>  </td>
                <td v-else> {{item.dob}} </td>
              </template>

            </CDataTable>   
        </div>

        <div class="col-md-6">
            <p>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} items</p>
        </div>
      
        <div class="col-md-6">
            <b-pagination
                v-model="meta.current_page"
                :total-rows="meta.total"
                :per-page="meta.per_page"
                align="right"
                @change="changePage"
                aria-controls="dw-datatable"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment';
import service from '@/services/service'
import axios from 'axios'
import store from '@/store.js'


export default {
  name: 'Table',
  props: {
    items: Array,
    depart: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    items: {
        type: Array,
        required: true
    },
    icare: {
        type: Array,
        required: true
    },
    fields: {
        type: Array,
        required: true
    },
    meta: {
        required: true
    },
    btn_show: {
        required: true
    },
    btn_edit: {
        required: true
    },
    btn_edit_phone: {
        required: true
    },
    btn_edit_address: {
        required: true
    },
    btn_edit_birthday: {
        required: true
    },
    btn_deactivate: {
        required: true
    },
    btn_reactivate: {
        required: true
    },
    btn_destroy: {
        required: true
    },
    is_uuid: {
        required: true
    },
    is_search_by_date: {
        required: true
    },

  },
  data() {
      return {
          sortBy: null, 
          sortDesc: false, 
          deleteModal: false,
          selected: null,
          selectID: null,
          inc: 5,
      }
  },
    watch: {
        sortBy(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        },
        sortDesc(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        }
    },
   methods:{

   getPhoto(data){
        if (data){
            return axios.defaults.baseURL + '/getfile/memberphoto/' + data
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    }, 
    openURL(data){
        this.$router.push({name:'Member Detail',query: {Pud:data} }) 
        }, 
    openURLICARE(data){
        this.$router.push({name:'iCare Detail',query: {Pud:data} }) 
        }, 
      loadPerPage(val) {
          this.$emit('per_page', this.meta.per_page)
      },

      loadIsActive(val) {
          this.$emit('is_active', this.meta.is_active)
      },
      loadIcareFilter(val) {
          this.$emit('icare_filter', this.meta.icare_id)
      },
      changePage(val) {
          this.$emit('pagination', val)
      },

      search: _.debounce(function (e) {
          this.$emit('search', e.target.value)
      }, 500),


      show: function (id) {
          this.$emit('show', id)
      },

      edit: function (id) {
          this.$emit('edit', id)
      },

      edit_phone: function (id) {
          this.$emit('editphone', id)
      },

      edit_address: function (id) {
          this.$emit('editaddress', id)
      },

      edit_birthday: function (id) {
          this.$emit('editbirthday', id)
      },

      deactivate: function (id) {
        this.$emit('deactivate', id)
      },
      
      reactivate: function (id) {
        this.$emit('reactivate', id)
      },

      destroy: function (id) {
        this.$emit('destroy', id)
      },

      resetpassword: function (id) {
        this.$emit('resetpassword', id)
      },

      grantwebaccess: function (id) {
        this.$emit('grantwebaccess', id)
      },   

      converttomember: function (id) {
        this.$emit('converttomember', id)
      },     

      frontEndDateFormat: function(date) {
        return moment(date, 'YYYY-MM-DD').format('DD MMMM YYYY');
      },

  }
 
}
</script>
